<template>
  <div>
    <div class="majorTitle">
      Two Factor Authentication
    </div>
    <p style="text-align: center;">
      Please enter the code sent to your email. The code expires in 15 minutes.
    </p>
    <div class="row update-container">
      <form @submit="updateAccount">
        <input
          v-model="pin"
          type="text"
          placeholder="Enter 6 digit code"
          class="input"
          required
        > 
                
        <div style="padding-top: 16px; padding-bottom: 32px">
          <label style="text-align: center;">Didn't receive a code? <a
            href="#"
            @click="resendCode()"
          >Resend Code</a></label>
        </div>
        <div class="bottom-buttons">
          <button
            id="exitButton"
            type="button"
            class="button"
            @click="exit()"
          >
            Exit
          </button>
          <button
            id="submitButton"
            type="submit"
            class="button"
          >
            Submit
          </button>
        </div>
      </form>
    </div>

    <LoadingOverlayComponent
      v-if="showLoading"
      :title="loadingTitle"
    />

    <AlertComponent
      v-if="showRegulatAlert"
      :title="regularAlertTitle"
      :message="regularAlertMessage"
      :secondary-action="null"
      @close="closeAlert()"
    />
  </div>
</template>

<script>

import LoadingOverlayComponent from '@/components/Shared/LoadingOverlayComponent.vue'
import AlertComponent from '@/components/Shared/AlertComponent.vue'
import apiMixin from '@/mixins/apiMixin.js'

export default {
    name: 'TwoFactorEmailPinComponent',
    components: {
        LoadingOverlayComponent,
        AlertComponent
    },
    mixins: [apiMixin],
    data () {
		return {
			loadingTitle: 'Gathering your account details',
            loadingSubTitle: '',
            showLoading: true, 

            showRegulatAlert: false,
            regularAlertTitle: '',
            regularAlertMessage: '',
            pin: '',
            customerId: '',
            processedEmail: null, // Track which email we've already processed
		}
	},
    computed: {
        
    },
    watch: {
        '$route': {
            immediate: true,
            handler() {
                this.checkForAccount()
            }
        }
    },
	mounted () {

	},
    methods: {
        verify2FA(email){
            var cmp = this
            let apiPayload = {}
            apiPayload.apiEndpoint = 'account'
            apiPayload.postData = {}
            apiPayload.postData.action = 'verify_user_2fa'
            apiPayload.postData.email = email

            cmp.$store.dispatch('apiCall', apiPayload).then(response => {
                this.showLoading = false

                if (response.data.result !== 'success') {
                    console.error(response.data.message)
                    this.exit()
                } else{
                    this.customerId = response.data.payload
                }
            })
        },
        updateAccount(e){
            e.preventDefault()
            var cmp = this
            let apiPayload = {}
            apiPayload.apiEndpoint = 'account'
            apiPayload.postData = {}
            apiPayload.postData.action = 'verify_pin'
            apiPayload.postData.pin = this.pin
            apiPayload.postData.customer_id = this.customerId

            this.loadingTitle = 'Veryfying Code'
            this.showLoading = true
            cmp.$store.dispatch('apiCall', apiPayload).then(response => {
                this.showLoading = false
                if (response.data.result !== 'success') {
                    this.regularAlertTitle = 'Error'
                    this.regularAlertMessage = response.data.message
                    this.shouldCloseModalAndNotExit = true // when the alert is closed, don't exit the page
                    this.showRegulatAlert = true
                } else{
                    this.regularAlertTitle = 'Code Verified!'
                    this.regularAlertMessage = 'You have successfully verified your account. You will now be redirected to the home page.'
                    this.shouldCloseModalAndNotExit = false // when the alert is closed, exit the page
                    this.showRegulatAlert = true
                    cmp.$store.dispatch('authenticate2FA', response.data.payload)
                }
            })
        },
        resendCode(){
            var cmp = this
            let apiPayload = {}
            apiPayload.apiEndpoint = 'account'
            apiPayload.postData = {}
            apiPayload.postData.action = 'resend_code'
            apiPayload.postData.customer_id = this.customerId

            this.loadingTitle = 'Sending a new code'
            this.showLoading = true
            cmp.$store.dispatch('apiCall', apiPayload).then(response => {
                this.showLoading = false
                if (response.data.result !== 'success') {
                    this.regularAlertTitle = 'Error'
                    this.regularAlertMessage = response.data.message
                    this.shouldCloseModalAndNotExit = true // when the alert is closed, don't exit the page
                    this.showRegulatAlert = true
                } else{
                    this.regularAlertTitle = 'Code Sent!'
                    this.regularAlertMessage = 'Please check your email for the new code.'
                    this.shouldCloseModalAndNotExit = true
                    this.showRegulatAlert = true
                }
            })
        },
        closeAlert(){
            this.showRegulatAlert = false
            if(this.shouldCloseModalAndNotExit === false){
                this.exit()
            }
        },
        exit() {
            window.location.replace(this.getUrlHost(this.$store.getters.apiPath))
        },
        checkForAccount() {
            const accountParam = this.$route.query.account
            let email = null
            
            // Try Vue Router query parameter first
            if(accountParam !== undefined && accountParam !== null && accountParam !== ''){
                try {
                    email = atob(accountParam)
                } catch (error) {
                    console.error('Error decoding Vue Router account parameter:', error)
                }
            }
            
            // Fallback to direct URL parsing if Vue Router hasn't parsed yet
            if (!email) {
                const urlParams = new URLSearchParams(window.location.search)
                const accountFromUrl = urlParams.get('account')
                
                if (accountFromUrl) {
                    try {
                        email = atob(accountFromUrl)
                    } catch (error) {
                        console.error('Error decoding URL account parameter:', error)
                    }
                }
            }
            
            // Only process if we have a valid email and haven't processed it yet
            if (email && email.includes('@') && email !== this.processedEmail) {
                this.processedEmail = email
                this.verify2FA(email)
            }
        }
    },
}
</script>

<style scoped>
    .update-container {
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 450px;
    }

    .top-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .toggle-label-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-bottom: 16px;
        padding-top: 16px;
        justify-content: center;
    }

    .toggle-label-container label {
        padding-right: 16px;
    }

    .bottom-buttons {
        margin-top: 16px;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    #submitButton {
        background-color: #007AFF;
        color: white;
        border: 1px solid #007AFF;
        border-radius: 8px;
    }

    #exitButton {
        background-color: #ffffff;
        color: #333333;
        border-radius: 8px;
        margin: 0;
        margin-right: 40px;
        border: 1px solid rgba(51, 51, 51, 0.7);
    }
</style>
